import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { useAtomValue } from 'jotai';
import { Box } from '@mui/material';
import { ParentSize } from '@visx/responsive';
import DonutChart from '../../../Components/Charts/DonutChart';
import GraphsLegend from '../../../Components/Charts/GraphsLegend';
import { allOutcomesAtom, themeAtom } from '../../../Atoms';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';

const OutcomeCallsWidget = function OutcomeCallsWidget({
  total = 0,
  sectionName = null,
  data = [],
}) {
  const intl = useIntl();
  const theme = useAtomValue(themeAtom);
  const outcomes = useAtomValue(allOutcomesAtom);

  const dataToShow = useMemo(
    () =>
      outcomes
        ?.map(({ id, name, color }) => ({
          id: intl.messages[name?.toUpperCase()] ?? capitalize(name),
          value: data
            ?.filter(({ outCome }) => id === outCome)
            //for each outcome sums all the performedCalls
            .reduce((acc, curr) => acc + curr.performedCalls, 0),
          color,
        }))
        ?.filter(({ value }) => value),
    [data]
  );

  return (
    <Box
      sx={{
        p: "1vh",
        display: "flex",
        height: "270px",
        width: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        justifyContent: "flex-start"
      }}>
      <ParentSize
        style={{
          width: '50%',
        }}
      >
        {(parent) => (
          //parent component passes his css properties to DonutChart
          (<DonutChart
            width={parent.width}
            height={parent.height}
            halfSize={parent.width / 2}
            dataToShow={dataToShow}
            total={total}
            text={sectionName}
            outcomes={outcomes}
            themeMode={theme}
          />)
        )}
      </ParentSize>
      <GraphsLegend
        height="90%"
        legendData={dataToShow?.map(({ id, value }) => `${id}: ${value}`)}
        legendColor={dataToShow?.map(({ color }) => color[theme])}
      />
    </Box>
  );
};

OutcomeCallsWidget.propTypes = {
  data: PropTypes.array,
  total: PropTypes.number,
  sectionName: PropTypes.string,
};

export default OutcomeCallsWidget;
